import { ActionsMenu } from "@idwal/idwal-react-components";
import { sendGAEvent } from "../../services/AnalyticsService";
import {
    DOWNLOAD_ORDER_CONFIRMATION_CLICK,
    ORDERS_ACTION_CLICK,
    VIEW_REPORT_CLICK
} from "../../utils/analytics";

export const OrdersBodyTemplate = (
    rowData: any, 
    showEarlyRelease: boolean,
    viewInspectionCallback: (rowData: any) => void,
    downloadInspectionCallback: (rowData: any) => void,
    t: any
) => {
    const menuItems = [
        ...showEarlyRelease ? [
            {
                label:  t("inspections.table.viewReport"),
                icon: <img 
                    className="pr-2" 
                    alt="request_inspection" 
                    src="./request-inspection-menu.svg">
                </img>,
                command: () => {
                    sendGAEvent(ORDERS_ACTION_CLICK, VIEW_REPORT_CLICK);
                    viewInspectionCallback(rowData);
                }
            }
        ] : [],
        {
            label: t("inspections.table.downloadPdf"),
            icon: <i style={{marginRight: '1rem'}} className="pi pi-download"></i>,
            command: () => {
                sendGAEvent(ORDERS_ACTION_CLICK, DOWNLOAD_ORDER_CONFIRMATION_CLICK);
                downloadInspectionCallback(rowData);
            }
        }
    ];

    return <ActionsMenu menuItems={menuItems}/>
}
